import { h, Component, Fragment } from "preact";
import Router from "preact-router";

import Prematch from "./prematch";
import PrematchEvent from "./prematch-event";
import Live from "./live";
import LiveEvent from "./live-event";
import Cashout from "./cashout";
import PrintOdds from "./print-odds";

import Casino from "./casino";
import PokerPage, { PokerPageDesktop } from "../../jamibet/desktop-pages/poker";

import ManagerLayout from "../../jamibet/desktop-components/user/manager-layout";
import ManagerTopupPopup from "../../jamibet/desktop-components/user/manager-topup-popup";
import { ManagerTransactionHistoryPopup } from "../../jamibet/desktop-components/user/manager-transaction-history";
import { UserTransactionHistoryPopup } from "../../jamibet/desktop-components/user/menu-dashboard";

import {PromoBody, ContentBody} from "./content";
import GenericPage from "./generic-page";
import { PopupGame } from "../../jamibet/mobile-pages/casino";
import BonusNotificationModal from "../../jamibet/desktop-components/site/BonusNotificationModal";
import {MagicLinkHandler} from "../../jamibet/desktop-components/site/MagicLinkHandler";
import {TournamentListPage} from "../../jamibet/desktop-pages/TournamentListPage";
import {TournamentLeaderboardPage} from "../../jamibet/desktop-pages/TournamentLeaderboardPage";
import { SignupRedirectDesktop } from "../../jamibet/desktop-pages/signup-redirect";
import RoyalWinsController from "../../jamibet/mobile-components/royal-wins";
import { ContactsPage } from "../../jamibet/desktop-components/user/menu-contact-us";
import { TotoPage } from "../../jamibet/desktop-pages/toto-jackpot";
import { TelegramOrchestrator } from "../../awrabet/mobile-components/telergram/TelegramOrchestrator";

export default function Desktop() {
	return <Fragment>
		<Router>
			<Prematch path="/prematch" default={true} />
			<PrematchEvent path="/prematch/:sportId/:categoryId/:tournamentId/:eventId" />
			<Live path="/live/general/:sportId?" />
			<LiveEvent path="/live/event/:eventId" />
			<Live path="/live/:sportId?" />
			<Cashout path="/cashout" />
			<PrintOdds path="/print-odds" />
			{/*<Casino path="/casino" />*/}
			<Casino path="/virtual/:type?/:pageCode?" />
			<Casino path="/special-games/:type?/:pageCode?" />
			<GenericPage Component={PromoBody} path="/promo/:any?/:any?" />
			<GenericPage Component={ContentBody} path="/content/:any?/:any?" />
			<GenericPage Component={ManagerLayout} path="/management/admin/:any?/:any?" />
			<GenericPage Component={ContentBody} path="/contacts" />
			{/* Tournament Routes */}
			<TournamentListPage path="/slot-tournaments" />
			<TournamentLeaderboardPage path="/slot-tournaments/:tournamentId" />
			<PokerPageDesktop path="/poker" />
			<SignupRedirectDesktop path="/signup" />

			<ManagerTopupPopup path="/admin/topup/:type/:id" />
			<ManagerTransactionHistoryPopup path="/admin/transactions/affiliate/:username" />
			<UserTransactionHistoryPopup path="/admin/transactions/player/:username" />
			<MagicLinkHandler path="/magic-link/:token" />
			
			<TelegramOrchestrator path="/tma-entry" />

			<TotoPage path="/jackpots/:tab?/:id?" />
		</Router>
		<RoyalWinsController />
		<PopupGame />
		<BonusNotificationModal />
	</Fragment>;
}
